import React, { useState, useEffect } from "react";
import Select, { components } from "react-select";
import AddIcon from "@mui/icons-material/Add";
import IconButton from "@mui/material/IconButton";
import { getServicetype } from "../services/FormService";
import ServiceForm from "./ServiceTypeModal";
import { colourStyles } from "./SelectStyles";
import Chip from "@mui/material/Chip";

const CustomOption = (props) => {
  return (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null}
        style={{ transform: "scale(1.3)", marginRight: "10px" }}
      />

      <label>{props.label}</label>
    </components.Option>
  );
};

const CustomMultiValue = () => null;

const CustomValueContainer = ({ children, ...props }) => {
  const count = props.getValue().length;
  const customText =
    count === 1 ? `${count} service selected` : `${count} services selected`;

  return (
    <components.ValueContainer {...props}>
      {count > 0 ? (
        <div style={{ marginRight: "10px" }}>{customText}</div>
      ) : null}
      {children}
    </components.ValueContainer>
  );
};

const CustomMultiValueRemove = () => null;

const CustomIndicatorSeparator = () => null;

const CustomDropdownIndicator = (props) => {
  const { isTextboxOpen } = props.selectProps;

  const handleButtonClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    props.selectProps.onNewClick();
  };

  const handleMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <components.DropdownIndicator {...props}>
      <div style={{ display: "flex", alignItems: "center", zIndex: 999 }}>
        <div style={{ backgroundColor: "#f2f2f2" }}>
          {isTextboxOpen && (
            <IconButton
              onClick={handleButtonClick}
              onMouseDown={handleMouseDown}
              size="small"
            >
              <AddIcon style={{ fontSize: 18 }} />
            </IconButton>
          )}
        </div>
      </div>
    </components.DropdownIndicator>
  );
};
function ServiceSelect({
  selectedServices,
  setSelectedServices,
  services,
  setServices,
}) {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const [isTextboxOpen, setIsTextboxOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [showNewButton, setShowNewButton] = useState(false);

  useEffect(() => {
    getServicetype()
      .then((response) => {
        setServices(response.data);
      })
      .catch((error) => {
        console.log("Error fetching service types:", error);
      });
  }, []);

  const handleTextboxOpen = () => {
    setIsTextboxOpen(true);
  };

  const handleTextboxClose = () => {
    setIsTextboxOpen(false);
  };

  const handleNewClick = () => {
    setModalIsOpen(true);
  };

  const handleChange = (selectedOptions) => {
    // console.log("selectedOptions", selectedOptions);
    setSelectedServices(selectedOptions || []);
  };

  const mapServicesToOptions = (services) => {
    return services.map((service) => ({
      value: service.slug,
      label: service.name,
      ...service,
    }));
  };

  const handleNewButtonClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setModalIsOpen(true);
  };

  const handleMenuOpen = () => {
    setShowNewButton(true);
    setIsTextboxOpen(true);
  };

  const handleMenuClose = () => {
    setShowNewButton(false);
    setTimeout(() => {
      setIsTextboxOpen(false);
    }, 500);
  };

  const handleInputChange = (value) => {
    setInputValue(value);
  };

  return (
    <div style={{ position: "relative" }}>
      <ServiceForm
        isOpen={modalIsOpen}
        onClose={() => setModalIsOpen(false)}
        services={services}
        setServices={setServices}
      />
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
      ></div>
      <Select
        isMulti
        options={mapServicesToOptions(services)}
        getOptionLabel={(option) => option.name}
        getOptionValue={(option) => option.slug}
        value={selectedServices}
        onChange={handleChange}
        maxMenuHeight={160}
        minMenuHeight={160}
        onInputChange={handleInputChange}
        onMenuOpen={handleMenuOpen}
        onMenuClose={handleMenuClose}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        components={{
          Option: CustomOption,
          MultiValue: CustomMultiValue,
          ValueContainer: CustomValueContainer,
          MultiValueRemove: CustomMultiValueRemove,
          IndicatorSeparator: null,
        }}
        placeholder="Select Service Type"
        styles={colourStyles}
        menuPortalTarget={document.body}
        isClearable={false}
      />
      {isTextboxOpen && inputValue === "" && services.length > 0 && (
        <button
          style={{
            position: "absolute",
            right: 3,
            bottom: "-12rem",
            zIndex: 999,
            textDecoration: "none",
            fontFamily: "Poppins",
            fontSize: "small",
            color: showNewButton ? "black" : "transparent",
            cursor: "pointer",
            border: "none",
            background: "none",
            padding: 0,
          }}
          onClick={handleNewButtonClick}
        >
          +New
        </button>
      )}
    </div>
  );
}

export default ServiceSelect;
